/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_IntroInputs */

const en_us2_board_intro = /** @type {(inputs: Board_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips and ideas from people who use the app. Every post is read by the team before it shows up here. The most supported ideas help decide what comes next, but the team decides and builds.`)
};

const pt_br2_board_intro = /** @type {(inputs: Board_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicas e ideias de quem usa o app. Toda publicação passa pela equipe antes de aparecer aqui. As ideias mais votadas ajudam a decidir o que vem depois, mas quem decide e constrói é a equipe.`)
};

const pt_pt2_board_intro = /** @type {(inputs: Board_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicas e ideias de quem usa o app. Toda publicação passa pela equipe antes de aparecer aqui. As ideias mais votadas ajudam a decidir o que vem depois, mas quem decide e constrói é a equipe.`)
};

/** @type {(inputs: Board_IntroInputs) => LocalizedString} */
const es_419_board_intro = en_us2_board_intro;

/** @type {(inputs: Board_IntroInputs) => LocalizedString} */
const fr_fr2_board_intro = en_us2_board_intro;

/** @type {(inputs: Board_IntroInputs) => LocalizedString} */
const de_de2_board_intro = en_us2_board_intro;

/** @type {(inputs: Board_IntroInputs) => LocalizedString} */
const it_it2_board_intro = en_us2_board_intro;

/**
* | output |
* | --- |
* | "Tips and ideas from people who use the app. Every post is read by the team before it shows up here. The most supported ideas help decide what comes next, but..." |
*
* @param {Board_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_intro = /** @type {((inputs?: Board_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_intro(inputs)
	if (locale === "es-419") return es_419_board_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_board_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_board_intro(inputs)
	if (locale === "de-DE") return de_de2_board_intro(inputs)
	if (locale === "it-IT") return it_it2_board_intro(inputs)
	return en_us2_board_intro(inputs)
});
export { board_intro as "board.intro" }